<template>
  <div v-show="open" class="chat-autocomplete px-4">
    <div class="grey600 pa-2 text-body-2">
      <div
        v-for="(option, i) in list" :key="option.value"
        class="autocomplete-item"
        :class="{'is-selected': selected === i}"
        @click="onItemClick(i)"
        @mouseenter="onItemMouseEnter(i)"
      >
        <component :is="option.type" :value="option.value" :meta="option.meta" />
      </div>
    </div>
  </div>
</template>

<script>

// TODO the onKeyDown should be in Chat.vue not input
export default {
  components: {
    emote: () => import('@/components/Chat/ChatAutocompleteContent/ChatAutocompleteEmote'),
    mention: () => import('@/components/Chat/ChatAutocompleteContent/ChatAutocompleteMention'),
  },
  props: {
    open: Boolean,
    selected: {
      type: Number,
      required: true,
    },
    list: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    selectedItem: {
      get() {
        return this.selected
      },
      set(val) {
        this.$emit('update:selected', val)
      },
    },
  },
  methods: {
    onItemClick(index) {
      this.$emit('input', index)
    },
    onItemMouseEnter(index) {
      this.selectedItem = index
    },
  },
}
</script>

<style lang="scss" scoped>
.chat-autocomplete {
  .autocomplete-item {
    cursor: pointer;

    &.is-selected {
      background-color: grey(500);
    }
  }
}
</style>
